import { forwardRef } from 'react';
import { useState, useEffect } from 'react';
import { Select, MenuItem } from '@mui/material';
import API from '@utils/axios';

const CustomerSelect = forwardRef(({ emptyLabel, ...params }, ref) => {
    const [customers, setCustomers] = useState([]);

    // Chargement de la liste des clients
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await API.get('/customers', {
                    params: {
                        sort: 'name',
                        direction: 'asc',
                        per_page: 9999,
                    }
                });
                if (response.data && Array.isArray(response.data.data)) {
                    setCustomers(response.data.data);
                } else {
                    setCustomers([]);
                }
            } catch (error) {
                setCustomers([]);
            }
        };
        fetchCustomers();
    }, []); // Pas de dépendance, donc le code s'exécute une seule fois

    return (
        <Select ref={ref} {...params} >
            {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
            {customers.map((customer) => (
                <MenuItem key={customer.id} value={customer.id}>
                    {customer.name}
                </MenuItem>
            ))}
        </Select>
    );
});

export default CustomerSelect;